/*
 * @Author: 小周
 * @Date: 2023-09-06 12:01:35
 * @LastEditTime: 2026-08-03 16:22:30
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description:
 */
import { RouterProvider } from 'react-router-dom'
import routerConfig from './router'
import './styles/index.scss'
import * as vConsole from 'vconsole'
import { appWxShare } from './weChat/index'
import useViewDxTrack from './hooks/useViewDxTrack'
import { getAppDoNotLoginUserInfo } from '@/oauth/appLogin'
import { trackArticleDetail } from './utils/aplusTrack'
import { ARTICLE_ID } from '@/constant'
const App = () => {
  var linkUrl = document.createElement('link')
  var scriptUrl = document.createElement('script')
  linkUrl.rel = 'stylesheet'
  if (process.env.NODE_ENV == 'production') {
    // css文件
    linkUrl.href =
      'https://res.hntv.tv/newlogin/login.css?v=' + new Date().getTime()
    document.head.appendChild(linkUrl)

    // js文件
    scriptUrl.src =
      'https://res.hntv.tv/newlogin/main.js?v=' + new Date().getTime()
    document.body.appendChild(scriptUrl)
  } else {
    // css文件
    linkUrl.href =
      'https://pre-res.hntv.tv/newlogin/login.css?v=' + new Date().getTime()
    document.head.appendChild(linkUrl)
    // js文件
    scriptUrl.src =
      'https://pre-res.hntv.tv/newlogin/main.js?v=' + new Date().getTime()
    document.body.appendChild(scriptUrl)
  }

  if (process.env.NODE_ENV != 'production') {
    new vConsole()
  }

  appWxShare()
  useViewDxTrack()
  getAppDoNotLoginUserInfo()
  trackArticleDetail(ARTICLE_ID)
  return <RouterProvider router={routerConfig} />
}

export default App
